import React, { useEffect, useState } from "react";

import {
    Box,
    Button,
    CircularProgress,
    Paper,
    Stack,
    Typography
} from "@mui/material";

import DownloadIcon from "@mui/icons-material/Download";

import AxiosInstance from "../../../services/AxiosInstance";
import { CHANGE_REQUEST_URL } from "../../../Constants/Constants";

const AttachmentsTab = ({
    change
}) => {

    const [attachments, setAttachments] =
        useState([]);

    const [loading, setLoading] =
        useState(true);


    useEffect(() => {

        const loadAttachments = async () => {

            try {

                const response =
                    await AxiosInstance.get(
                        `${CHANGE_REQUEST_URL}/${change.id}/attachments`
                    );

                setAttachments(
                    response.data?.data ||
                    response.data ||
                    []
                );

            } catch (error) {

                console.error(
                    "Unable to load attachments",
                    error
                );

            } finally {

                setLoading(false);
            }
        };


        if (change.id) {
            loadAttachments();
        }

    }, [change.id]);


    const downloadAttachment = async (
        attachment
    ) => {

        try {

            const response =
                await AxiosInstance.get(
                    `${CHANGE_REQUEST_URL}/attachments/${attachment.id}/download`,
                    {
                        responseType: "blob"
                    }
                );


            const url =
                window.URL.createObjectURL(
                    new Blob([
                        response.data
                    ])
                );


            const link =
                document.createElement("a");

            link.href = url;

            link.download =
                attachment.originalFileName ||
                "attachment";

            document.body.appendChild(link);

            link.click();

            link.remove();

            window.URL.revokeObjectURL(url);

        } catch (error) {

            console.error(
                "Unable to download attachment",
                error
            );
        }
    };


    if (loading) {

        return (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    p: 5
                }}
            >
                <CircularProgress />
            </Box>
        );
    }


    return (

        <Box>

            <Typography
                variant="h6"
                fontWeight={600}
                sx={{ mb: 2 }}
            >
                Attachments
            </Typography>


            {attachments.length === 0 ? (

                <Typography
                    color="text.secondary"
                >
                    No attachments available.
                </Typography>

            ) : (

                <Stack spacing={1}>

                    {attachments.map(
                        attachment => (

                            <Paper
                                key={attachment.id}
                                variant="outlined"
                                sx={{
                                    p: 2,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent:
                                        "space-between"
                                }}
                            >

                                <Box>

                                    <Typography
                                        fontWeight={600}
                                    >
                                        {
                                            attachment.originalFileName
                                        }
                                    </Typography>

                                    <Typography
                                        variant="caption"
                                        color="text.secondary"
                                    >
                                        {
                                            attachment.contentType ||
                                            "-"
                                        }
                                        {" • "}
                                        {
                                            attachment.fileSize ||
                                            0
                                        } bytes
                                    </Typography>

                                </Box>


                                <Button
                                    size="small"
                                    startIcon={
                                        <DownloadIcon />
                                    }
                                    onClick={() =>
                                        downloadAttachment(
                                            attachment
                                        )
                                    }
                                >
                                    Download
                                </Button>

                            </Paper>

                        )
                    )}

                </Stack>

            )}

        </Box>
    );
};


export default AttachmentsTab;